import React, { useEffect, useState, useContext, useCallback } from 'react';
import axios from 'axios';
import { AuthContext } from '../../Auth/context/AuthContext.js';
import { AlertCircle } from 'lucide-react';

export default function ForemenPage() {
  const { auth } = useContext(AuthContext);
  const [foremen, setForemen] = useState([]);
  const [showInactive, setShowInactive] = useState(false);
  const [statusMessage, setStatusMessage] = useState('');

  const fetchForemen = useCallback(() => {
    axios.get('/api/myteconstruction/personnel', {
      headers: { Authorization: `Bearer ${auth.token}` },
      params: { role: 'Foreman', status: showInactive ? 'inactive' : 'active' }
    })
    .then(res => setForemen(res.data.personnel || []))
    .catch(err => { console.error(err); setStatusMessage('Failed to fetch foremen.'); });
  }, [auth.token, showInactive]);

  useEffect(() => {
    if (auth.token) fetchForemen();
  }, [fetchForemen, auth.token]);

  const handleRemove = async (id) => {
    if (!window.confirm('Remove this foreman?')) return;
    try {
      await axios.delete(`/api/myteconstruction/personnel/${id}`, { headers: { Authorization: `Bearer ${auth.token}` } });
      fetchForemen();
    } catch (err) { console.error(err); setStatusMessage('Failed to remove foreman.'); }
  };
  const handleReactivate = async (id) => {
    try {
      await axios.put(`/api/myteconstruction/personnel/${id}/reactivate`, {}, { headers: { Authorization: `Bearer ${auth.token}` } });
      fetchForemen();
    } catch (err) { console.error(err); setStatusMessage('Failed to reactivate foreman.'); }
  };

  if (!auth.token) {
    return (
      <div className="p-4 bg-gray-950 text-white">
        <p>Please log in to view Foremen.</p>
      </div>
    );
  }

  return (
    <div className="p-4 bg-gray-950 text-white min-h-screen">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold">Foremen</h1>
        <div className="space-x-2">
          <button onClick={() => setShowInactive(false)} disabled={!showInactive}
            className="px-2 py-1 rounded bg-blue-600 disabled:opacity-50">Active</button>
          <button onClick={() => setShowInactive(true)} disabled={showInactive}
            className="px-2 py-1 rounded bg-blue-600 disabled:opacity-50">Inactive</button>
        </div>
      </div>
      {statusMessage && (
        <div className="mb-4 text-sm text-red-400 flex items-center gap-1">
          <AlertCircle className="h-4 w-4" /> {statusMessage}
        </div>
      )}
      <table className="w-full text-left text-gray-300">
        <thead>
          <tr className="border-b border-gray-700">
            <th className="px-2 py-1">Name</th>
            <th className="px-2 py-1">Email</th>
            <th className="px-2 py-1">Status</th>
            <th className="px-2 py-1">Invited At</th>
            <th className="px-2 py-1">Accepted At</th>
            <th className="px-2 py-1">Actions</th>
          </tr>
        </thead>
        <tbody>
          {foremen.map(p => (
            <tr key={p._id} className="odd:bg-gray-900 even:bg-gray-800">
              <td className="px-2 py-1 text-white">{p.contactId?.name}</td>
              <td className="px-2 py-1">{p.contactId?.email}</td>
              <td className="px-2 py-1 capitalized">{p.status}</td>
              <td className="px-2 py-1">{new Date(p.invitedAt).toLocaleDateString()}</td>
              <td className="px-2 py-1">{p.acceptedAt ? new Date(p.acceptedAt).toLocaleDateString() : '-'}</td>
              <td className="px-2 py-1 space-x-2">
                {p.status==='active' ? (
                  <button onClick={()=>handleRemove(p._id)} className="px-2 py-1 bg-red-600 rounded">Remove</button>
                ) : (
                  <button onClick={()=>handleReactivate(p._id)} className="px-2 py-1 bg-green-600 rounded">Reactivate</button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}